import GovAgencyRegisterForm from '../../components/gov/GovAgencyRegisterForm';
import SEO from '../../components/SEO';

export default function GovRegisterPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <SEO
        title="Government Agency Registration - Solar Contracting"
        description="Register your government agency on Evoltbay for solar contracting and procurement. Access certified solar vendors, RFQ tools, and GSA-compliant solar equipment sourcing."
        keywords="government solar contracting, government agency registration, solar procurement, GSA solar, government solar vendors, solar RFQ government"
        url="https://evoltbay.com/gov/register"
      />
      <div className="container mx-auto px-4">
        <GovAgencyRegisterForm />
      </div>
    </div>
  );
} 